<template>
  <form ref="form" @submit.prevent.stop="processForm" autocomplete="off" class="position-relative" :class="{'non-scrollable':!enableScrolling}">
    <Griddle/>

    <slot name="default"
          :fieldsToDisplay="fieldsToDisplay"
          :fieldValues="fieldValues"
          :fieldErrors="fieldErrors"
    >
    </slot>

    <div  v-if="fields.length">
      <div >
        <slot
            name="renderQuestions"
            :fieldsToDisplay="fieldsToDisplay"
            :skipEagerValidation="skipEagerValidation"
            :allAvailableFields="allAvailableFields"
            :fieldValues="fieldValues"
            :fieldErrors="fieldErrors"
            :handleFieldChange="handleFieldChange"
            :handleAddressChange="handleAddressChange"
            :handleFieldError="handleFieldError"
            :setDisplayFields="setDisplayFields"
        >
          <template v-for="(item, idx) in (groupAsAccordion ?  groupBySections:fieldsAfterGroupErrors)" :key="idx">
            <AccordionContainer
                v-if="Array.isArray(item) && groupAsAccordion"
                :sectionName="item[0]?.section"
                :fields="item"
                :idx="idx"
                :HARD_CODED_ADDRESS_GROUPING="HARD_CODED_ADDRESS_GROUPING"
                :DYNAMIC_ADDRESS_GROUPING="DYNAMIC_ADDRESS_GROUPING"
                :hideSubText="disableHelp"
                :skipEagerValidation="skipEagerValidation"
                :enableEagerValidation="enableEagerValidation"
                :forcePromptPlaceholder="forcePromptPlaceholder"
                :sectionDisplayMap="sectionDisplayMap"
                :disablePrompt="true"
                :isOpenDefault="accordionOpen === item[0]?.section"
                :loadingRules="loadingRules"
                :fieldValues="fieldValues"
                :fieldErrors="fieldErrors"
                :fieldsInteractedWith="fieldsInteractedWith"
                :runningRulesFor="runningRulesFor"
                @manually-open="accordionOpen = $event"
                @field-error="handleFieldError"
                @user-interaction="fieldsInteractedWith[$event]=true"
                @delete="handleDelete(item)"
                @field-change="handleFieldChange"
                @address-change="handleAddressChange"
            >
              <slot v-if="this.$slots[`Field_${item.name}`]" :name="`Field_${item.name}`"
                    :handleFieldChange="handleFieldChange" :question="item"/>
            </AccordionContainer>
            <slot v-else-if="this.$slots[`Field_${item.name}`]" :name="`Field_${item.name}`"
                  :handleFieldChange="handleFieldChange" :question="item"/>
            <Timer v-else-if="item.name === 'Timer'" :item="item" @onTimeout="processForm">
            </Timer>
            <div ref="questionRef" v-else-if="item.status === 'HIDDEN'"/>
            <Question
                ref="questionRef"
                v-else-if="!HARD_CODED_ADDRESS_GROUPING[item.name] && !DYNAMIC_ADDRESS_GROUPING(item.name)"

                :key="idx"
                :index="idx"
                :isVgsFormReady="isVgsFormReady"
                :vgsFieldsReady="vgsFieldsReady"
                :vgsFieldState="vgsFieldState"
                :disableConfirm="!enableScrolling || disableConfirm || isPopUp || (item?.section && item?.section === fieldsAfterGroupErrors[idx + 1]?.section) || allEditableFields[allEditableFields.length -1]?.name === item.name"
                :isRevisiting="isRevisiting"
                :hasBeenInteractedWith="fieldsInteractedWith[item.name]"
                :runningRulesFor="runningRulesFor === item.name"
                :enableScrolling="enableScrolling"
                :isPopUp="isPopUp"
                :showSectionPrompts="showSectionPrompts"
                :sectionPrompt="!disableSectionLabel && sectionDisplayMap[item.section] === item.name ? item.section:null"
                :hidePrompt="!showSectionPrompts && (item.section) || disablePrompt"
                :hideHelp="(item.section && sectionDisplayMap[item.section] !== item.name) || disableTooltips"
                :groupError="idx + 1 === fieldsToDisplay.length && (item?.section !== fieldsAfterGroupErrors[idx + 1]?.section) ? groupErrors[item.section]:null"
                :hideSubText="item.type !== 'switch' && (disableHelp || (item?.section && item?.section === fieldsAfterGroupErrors[idx + 1]?.section)) && fieldsAfterGroupErrors.length !== (idx + 1)"
                :fields="this.allAvailableFields"
                :forcePromptPlaceholder="forcePromptPlaceholder"
                :class="{
                  unanswered: (!fieldValues[item.name] || fieldErrors[item.name] || (fieldValues[item.name] && !fieldsInteractedWith[item.name])),
                  grouped: item.section && sectionDisplayMap[item.section] !== item.name,
                  revisiting: isRevisiting,
                }"
                :currentActiveQuestion="currentActiveQuestion"
                :loadingRules="loadingRules"
                :skipEagerValidation=" !enableEagerValidation && (disableEagerValidation || skipEagerValidation)"
                :question="item"
                @field-error="handleFieldError"
                @field-change="handleFieldChange"
                @address-change="handleAddressChange"
                @scrollToNextQuestion="scrollToQuestion(item, true)"
                @removeVgsField="handleRemoveVgsField"
                @loadVgsField="loadVgsField"
                @user-interaction="fieldsInteractedWith[$event]=true"
                @prelim-update="fieldValues = {...fieldValues, [$event.field_name]:$event.value}"
            ></Question>
          </template>
        </slot>
      </div>
      <div style="max-width: fit-content" v-if="this.$slots.aside">
        <slot
            name="aside"
            :fieldsToDisplay="fieldsToDisplay"
            :fieldValues="fieldValues"
            :fieldErrors="fieldErrors"
            :handleFieldChange="handleFieldChange"
        ></slot>
      </div>
    </div>
    <div class="form-actions">
      <slot :formHasBeenSubmitted="formHasBeenSubmitted" :formHasBeenEdited="formHasBeenEdited"
            :loadingRules="loadingRules"
            :formError="!(isVgsForm ? (allVgsFieldsLoaded && allVgsFieldsValid):true) || isDisabled"
            name="form-actions">
      </slot>
      <slot name="post-actions"></slot>
    </div>
  </form>
</template>
<script>
import backend from "@/components/waffle/backend";
import Timer from "@/components/waffle/components/Timer.vue";
import Question from "@/components/waffle/components/Question.vue";
import AccordionContainer from "@/components/waffle/components/form-components/AccordionContainer.vue";
import Griddle from "@/components/waffle/components/Griddle";
import {loadVGSCollect} from "@vgs/collect-js";
import {toRaw} from "vue";
import {debounce} from "@/components/waffle/utils/debouce";

export default {
  name: 'QuestionContainer',
  expose: ['fieldsToDisplay', 'fieldValues','fieldErrors'],
  inject: ['getCurrentURL', 'formSubmitted', 'vgsSubmit', 'navigate', 'isPopUp'],
  components: {AccordionContainer, Timer, Question, Griddle},
  props: {
    fields: {
      type: Array,
      required: false,
      default: () => []
    },
    nativeControl: Boolean,
    ruleOverrides: {
      type: Object,
      default: () => ({})
    },
    disablePrompt: Boolean,
    disableTooltips: Boolean,
    disableHelp: Boolean,
    disableConfirm: Boolean,
    disableEagerValidation: Boolean,
    disableSectionLabel:Boolean,
    forcePromptPlaceholder: Boolean,
    skipGrouping: Boolean,
    enableEagerValidation: Boolean,
    groupAsAccordion: Boolean,
    showSectionPrompts: Boolean,
    enableScrolling:{
      type:Boolean,
      default(){
        return false
      }
    }
  },
  data() {
    return {
      allAvailableFields: null,
      fieldsToDisplay: [],
      fieldsInteractedWith:{},
      fieldValues: {},
      sectionDisplayMap: {},
      fieldErrors: {},
      loadingRules: false,
      skipEagerValidation: false,
      formHasBeenEdited: false,
      formHasBeenSubmitted: false,
      slotState: {},
      currentActiveQuestion:null,
      suspendProcess: false,
      runningRulesFor:null,
      accordionOpen:null,
      //vgs related state
      vgsForm: null,
      vgsFieldsReady: {},
      vgsFieldNameToQuestionFieldName:{},
      isVgsFormReady: false,
      vgsFieldState: {},
      collect: null,
      isRevisiting:sessionStorage.getItem(this.getCurrentURL()),
      isVgsForm:false
    }
  },
  created() {
    const isVgs = this.fields.find(field => field.type?.includes('vgs'))
    this.isVgsForm = isVgs

    if (isVgs) {
      this.vgsLoaderAzure()
    }
  },
  mounted() {
    if ('visualViewport' in window) {
      if(this.$isMobile()){
        window.visualViewport.addEventListener('resize', this.resizeHandler);
      }
    }

    this.fieldsToDisplay = JSON.parse(JSON.stringify(this.fields)) || [];
    this.allAvailableFields = JSON.parse(JSON.stringify(this.fields));
    this.fieldValues = this.fieldsToDisplay.reduce((acc, question) => {
      acc[question.name] = question.value || null
      return acc
    }, {})
    this.fieldsInteractedWith = this.fieldsToDisplay.reduce((acc, curr) => {
      acc[curr.name] = false
      return acc
    }, {})
    this.sectionDisplayMap = this.fieldsToDisplay.reduce((acc, curr) => {
      if (this.skipGrouping) return acc;

      if (curr.section && !acc[curr.section] && curr.status !== 'HIDDEN') {
        acc[curr.section] = curr.name
      }
      return acc
    }, {})

    this.fieldErrors = this.fieldsToDisplay.reduce((acc, curr) => {
          acc[curr.name] = Boolean(curr.error)
          return acc
        }, {}
    )

    if (sessionStorage.getItem(this.getCurrentURL())) {
      this.skipEagerValidation = false;
    } else {
      this.skipEagerValidation = true;
    }
    if(this.enableScrolling){
      this.scrollToQuestion();
    }
  },
  beforeUnmount() {
    if(this.$isMobile()){
      window.visualViewport.removeEventListener('resize', this.resizeHandler);
    }
  },
  watch: {
    fields: {
      handler: function (newFields) {
        this.formHasBeenSubmitted = false
        const fieldsToDelete = []
        this.fieldsToDisplay.forEach((field, i) => {
          const newFieldConfig = newFields.find(el => el.name === field.name)
          if (newFieldConfig) {
            this.fieldsToDisplay[i] = newFieldConfig
          }else{
            fieldsToDelete.push(i)
          }
        })
        fieldsToDelete.forEach(index => this.fieldsToDisplay.splice(index, 1))
      },
      deep: true
    },
    suspendProcess(newVal, oldVal){
      if(!newVal && oldVal){
        this.processForm()
      }
    },
    groupBySections(next, prev){
      if(this.groupAsAccordion){
        const previousSections = prev.map(el => el[0]?.section).filter(el => el)
        const nextSectionsMap = next.reduce((acc, curr) => {
          if(Array.isArray(curr) && curr[0]?.section){
            acc[curr[0].section] = false;
          }
          return acc
        },{})

        previousSections.forEach(s => nextSectionsMap[s] = true)
        this.accordionOpen = Object.entries(nextSectionsMap ?? {})?.find(entry => !entry[1] )?.[0] ?? this.accordionOpen
      }
    },
    vgsFieldsReady:{
      handler(newVal){
        this.isVgsForm = Object.keys(newVal).length;
  },
      deep:true
    }
  },
  computed: {
    allEditableFields(){
      return this.fieldsAfterGroupErrors.filter(q => q.status === 'EDITABLE')
    },
    isDisabled() {
      return !(this.fieldsToDisplay.every(field => {
        if (field.required && field.status !== 'HIDDEN' && !field.type.includes('vgs')) {
          return Boolean(this.fieldValues[field.name])
        }
        return true
      })) || Object.entries(this.fieldErrors || {}).some(([k, el]) => el && this.allFieldConfigsMap[k].status !== 'HIDDEN')
    },
    allFieldConfigsMap() {
      return this.fieldsToDisplay.reduce((acc, curr) => {
        acc[curr.name] = curr
        return acc
      }, {})
    },
    fieldsAfterGroupErrors() {
      return this.fieldsToDisplay.map(el => this.groupErrors[el.section] ? {...el, error: ''} : el)
    },
    groupErrors() {
      const groups = this.fieldsToDisplay.reduce((acc, curr) => {
        if (curr.section && acc[curr.section]) {
          acc[curr.section].push(curr)
        } else if (curr.section) {
          acc[curr.section] = [curr]
        }
        return acc
      }, {})

      return Object.keys(groups).reduce((acc, curr) => {
        const hasGroupError = groups[curr]?.every((q, i, arr) => (q.error && (i + 1 !== arr.length ? q.error === arr[i + 1]?.error : true)))
        if (hasGroupError) {
          acc[curr] = groups[curr][0]?.error
        }
        return acc;
      }, {})
    },
    HARD_CODED_ADDRESS_GROUPING() {
//TODO:RETHINK THIS AFTER DELIVERY

      return {
        // QTE_ResidentialStreetAddress: true,
        QTE_ResidentialUnitNumber: true,
        QTE_ResidenceCity: true,
        QTE_State: true,
        QTE_ResidenceZip: true,
        // QTE_PRP_StreetAddress: true,
        QTE_PRP_Address2: true,
        QTE_PRP_City: true,
        QTE_PRP_State: true,
        QTE_PRP_ZipCode: true,
        // QTE_PriorResidenceAddress: true,
        QTE_PriorResidenceCity: true,
        QTE_PriorResidenceState: true,
        QTE_PriorResidenceZip: true,
        // QTE_MailStreetAddress: true,
        QTE_MailCity: true,
        QTE_MailState: true,
        QTE_MailZip: true,
        // QTE_PRP_MailingStreetAddress: true,
        QTE_PRP_MailingAddress2: true,
        QTE_PRP_MailingCity: true,
        QTE_PRP_MailingState: true,
        QTE_PRP_MailingZipCode: true,
        // QTE_PRP_BillingStreetAddress: true,
        QTE_PRP_BillingCity: true,
        QTE_PRP_BillingState: true,
        QTE_PRP_BillingZip: true,
      }
    },
    groupBySections() {
      return Object.values(this.fieldsToDisplay?.filter(f => f.status !== 'HIDDEN').reduce((acc, curr) => {
        if (curr.section) {
          if (acc[curr.section]) {
            acc[curr.section].push(curr)
          } else {
            acc[curr.section] = [curr]
          }
        } else {
          acc[curr.name] = curr
        }
        return acc
      }, {}) || {})
    },
    //VGS related computations
    allVgsFieldsLoaded() {
      return Object.values(this.vgsFieldsReady).every(el => el)
    },
    allVgsFieldsValid() {
      return Object.values(toRaw(this.vgsFieldState) ?? {x: {isValid: false}})?.every(el => el.isValid)
    },
  },
  methods: {
    resizeHandler:function (event) {
      //for handling when mobile keyboard is opened
      const top = document.querySelector('.sticky-top')
      const VIEWPORT_VS_CLIENT_HEIGHT_RATIO = 0.75;
      if (
          ((event.target.height * event.target.scale) / window.screen.height <
          VIEWPORT_VS_CLIENT_HEIGHT_RATIO ) && top
      )
        top.style.position = 'static'
      else if(top){
        top.style.position='sticky'
      }
    },
    DYNAMIC_ADDRESS_GROUPING(name){
      const regexs = [ /QTE_VEH_\d+_LeaseCity/, /QTE_VEH_\d+_LeaseState/,/QTE_VEH_\d+_LeaseZip/]
      return regexs.some(r => r.test(name))
    },
    setSlotState(key, value) {
      this.slotState[key] = value;
      this.$forceUpdate()
    },
    setDisplayFields(newValues) {
      const newValueNames = newValues.map(el => el.name)
      const allFieldValues = Object.keys(this.fieldValues)
      const fieldsToRemove = allFieldValues.filter(el => newValueNames.indexOf(el) === -1);
      const fieldsToAdd = newValueNames.filter(el => allFieldValues.indexOf(el) === -1)

      fieldsToRemove.forEach(el => {
        delete this.fieldValues[el]
        delete this.fieldErrors[el]
      })
      fieldsToAdd.forEach(el => {
        const field = newValues.find(f => f.name === el.name)
        this.fieldValues[el] = field?.value ?? null
        this.fieldErrors[el] = Boolean(field?.error)
      })

      this.sectionDisplayMap = newValues.reduce((acc, curr) => {
        if (this.skipGrouping) return acc;

        if (curr.section && !acc[curr.section] && curr.status !== 'HIDDEN') {
          acc[curr.section] = curr.name
        }
        return acc
      }, {})
      this.fieldsToDisplay = newValues
      this.$forceUpdate()
    },
    handleFieldError(e) {
      this.fieldErrors[e.field_name] = e.hasError
      const isInputFocused = document.querySelector('input:focus')
        if(
            this.$isMobile() &&
            e.hasError &&
            !isInputFocused
        ){
          this.scrollToQuestion(this.fieldsToDisplay.find(el => el.name === e.field_name), false, true)
        }
    },
    handleDelete(fields) {
      let field_name = fields[0].name;
      if (field_name.startsWith('QTE_PRP_MTG_'))
        this.navigate('/' + this.getCurrentURL() + '/remove:' + field_name.replace('QTE_PRP_MTG_','').substring(0,2).replace('_',''));
      else if (field_name.startsWith('QTE_PRP_SCH_'))
        this.navigate('/' + this.getCurrentURL() + '/remove:' + field_name.replace('QTE_PRP_SCH_','').substring(0,2).replace('_',''));
      else
        console.error('accordion-delete not configured for "%s"', field_name);
    },
    scrollToQuestion(confirmField, forceNextQuestion, disableBlur) {
      if(this.enableScrolling && this.fieldsToDisplay.length){
        //In the event that the user comes back to a page or has prefilled values,
        //we need to eagerly update the entire section for scroll to move past the section since the continue button is for the section as a whole
        if(confirmField?.prefilled && confirmField?.section){
          this.fieldsToDisplay.filter(f => f.section === confirmField.section).forEach(f => {
            this.fieldsInteractedWith[f.name] =true
          })
        }

        this.$nextTick(() => {
          let $unanswered = !this.isRevisiting ? this.$refs.form?.querySelector('form:not(.non-scrollable) .quill-question:nth-child(-n+1 of .unanswered)'):null;
          if(!$unanswered && !this.isRevisiting || forceNextQuestion){
            const startIndex = this.fieldsToDisplay.findIndex(q => confirmField?.name === q.name)
            const nextQuestionsArr = this.fieldsToDisplay.slice(startIndex + 1)
            const nextQuestion = nextQuestionsArr.find(q => q.status !== 'HIDDEN' && ( !confirmField?.type?.includes('address') || confirmField?.type?.includes('address') && !q?.type?.includes('address') && !this.DYNAMIC_ADDRESS_GROUPING(q?.name) && !this.HARD_CODED_ADDRESS_GROUPING[q?.name]))

            if(nextQuestion){
              $unanswered = this.$refs.questionRef?.find(ref => ref.question?.name === nextQuestion?.name)?.$el
            }else if(this.$isMobile() && !$unanswered){
              $unanswered = this.$refs.questionRef?.find(ref => ref.question?.name === confirmField?.name)?.$el
              if(confirmField?.section){
                const firstInSection = this.fieldsToDisplay.find(el => el.section === confirmField.section)
                $unanswered = this.$refs.questionRef?.find(ref => ref.question?.name === firstInSection?.name)?.$el
              }
            }
          }

          if($unanswered?.classList?.contains('grouped') && this.fieldErrors[confirmField.name] && confirmField?.section){
            const firstInSection = this.fieldsToDisplay.find(el => el.section === confirmField.section)
            $unanswered = this.$refs.questionRef?.find(ref => ref.question?.name === firstInSection?.name)?.$el
          }

          if ($unanswered && !$unanswered?.closest('.accordion-body') && !$unanswered?.classList?.contains('grouped')
              &&  (($unanswered !== this.$refs.form?.querySelector('.quill-question') && !arguments.length) || arguments.length) ){
            if(this.$isMobile() && !disableBlur){
              document.querySelector('input:focus')?.blur()
            }
            const stickyTop = document.querySelector('.sticky-top')
            const scroll = {
              scrollTo: $unanswered, // scrollTo is also allowed to be number
              duration: 350,
              updateHistory: false,
              offset: -(stickyTop? stickyTop.getBoundingClientRect()?.height:16 )
            }

            this.$smoothScroll(scroll)
            $unanswered.classList.add('opacity-100')
            setTimeout(() => {
              if(!this.$isMobile()){
                $unanswered.querySelector('input')?.focus()
              }
            }, 700)
          }
          const name = $unanswered?.className?.split('quill-question')?.find(c => c.startsWith('-'))?.split(' ')?.[0]?.substring(1)
          const questionConfig = this.fieldsToDisplay.find(el => el.name === name)

          this.currentActiveQuestion = questionConfig
          if(questionConfig?.section){
            const sectionFields = this.$refs.questionRef?.filter(r => r?.question?.section === questionConfig.section)
            sectionFields.forEach(qRef => qRef?.$el?.classList.add('opacity-100'))
          }
        });
      }
    },
    handleAddressChange(e) {
      this.formHasBeenEdited = true
      Object.keys(e).forEach(field => {
        this.fieldValues[field] = e[field]
      })
    },
    processForm: debounce(function(e) {
      if(this.loadingRules) {
        this.suspendProcess = true;
        return;
      }
      //TODO:Remove when btn disable is in place
      if (this.isDisabled) return;

      const formValues = this.nativeControl ? {
        fields: Object.entries(Object.fromEntries(new FormData(e.target))).filter(([k]) => !k.endsWith('_purge'))
            .map(([k, v]) => ({field_name: k, field_value: v}))
      } : {
        fields: this.fieldsToDisplay.map(el => ({
          field_name: el.name,
          field_value: this.fieldValues[el.name]
        }))
      }
      this.formHasBeenSubmitted = true;
      this.$nextTick(() => {
        if(!this.isVgsForm ){
          this.formSubmitted(formValues)
        }else{
          const ccFields = {
            QTE_PRP_CreditCardNumber: 'QTE_PRP_CreditCardType',
            QTE_CreditCardNumber:'QTE_CreditCardType'
          }
          Object.keys(this.vgsFieldState).forEach(vgsPointer => {
            if(ccFields[this.vgsFieldNameToQuestionFieldName[vgsPointer]]){
              const fieldToModify = formValues.fields.find(el => (ccFields[this.vgsFieldNameToQuestionFieldName[vgsPointer]] === el.field_name))
              if(!fieldToModify) return;
              return fieldToModify.field_value = this.vgsFieldState[vgsPointer].cardType
            }
          })
          this.vgsSubmit(formValues, this.vgsForm)
        }
      });
      sessionStorage.setItem(this.getCurrentURL(), 'true')
    }, 750),
    handleFieldChange: async function ({fieldValue, fieldConfig, cbk}) {
      this.formHasBeenEdited = true;

      const shouldCheckRule = fieldConfig.criteria && fieldConfig.criteria.some(c => typeof c === 'string' && c === 'api')
      if (shouldCheckRule) {
        this.loadingRules = true
        this.runningRulesFor= fieldConfig.name;
        let ruleData = {
          "criteria": fieldConfig.name,
          path: ('/' + this.getCurrentURL()).replace('//','/'),
          "fields": [
            ...Object.keys(this.fieldValues).reduce((acc, k) => {
              if (k !== fieldConfig.name) {
                acc.push({
                  "field_name": k,
                  "field_value": (this.fieldValues[k] || null)
                })
              }
              return acc
            }, []),
            {
              "field_name": fieldConfig.name,
              "field_value": fieldValue || null
            }
          ]
        }
        let response;
        if (this.ruleOverrides[ruleData.criteria]) {
          response = this.ruleOverrides[ruleData.criteria](ruleData);
          console.log('rule-override %o %o', ruleData, response);
        } else {
          ruleData.fields = ruleData.fields.filter(f => !f.field_name.startsWith('Waffle_'))
          response = await backend.postData('rule', ruleData)
        }
        this.runningRulesFor= null;
        this.loadingRules = false
        if (response.data.status === 'FAILURE' && response.data.errorMessage) {
          throw response
        }

        if (response.data.redirectURL) {
          return this.navigate(response.data.redirectURL);
        }

        const replaceConfigMap = (response.data.fields || []).reduce((acc, field) => {
          acc[field.name] = {
            newConfig: field,
            index: this.fieldsToDisplay.findIndex(el => el.name === field.name)
          }
          return acc
        }, {})

        Object.keys(replaceConfigMap).forEach(k => {
          if (replaceConfigMap[k].index > -1) {
            if (replaceConfigMap[k].newConfig?.error) {
              this.fieldsToDisplay.splice(replaceConfigMap[k].index, 1, {...this.fieldsToDisplay[replaceConfigMap[k].index], ...replaceConfigMap[k].newConfig})
            } else {
              this.fieldsToDisplay.splice(replaceConfigMap[k].index, 1, replaceConfigMap[k].newConfig)
            }
          } else {
            this.fieldsInteractedWith[replaceConfigMap[k].newConfig?.name] = false;
            this.fieldsToDisplay.push(replaceConfigMap[k].newConfig)
          }
          this.fieldValues[k] = replaceConfigMap[k].newConfig.value
        })
      }
      this.fieldValues[fieldConfig.name] = fieldValue

      this.sectionDisplayMap = this.fieldsToDisplay.reduce((acc, curr) => {
        if (this.skipGrouping) return acc;

        if (curr.section && !acc[curr.section] && curr.status !== 'HIDDEN') {
          acc[curr.section] = curr.name
        }
        return acc
      }, {})
      this.allAvailableFields = JSON.parse(JSON.stringify(this.fieldsToDisplay));
      this.scrollToQuestion(fieldConfig);
      this.suspendProcess = false;
      if (cbk) cbk();
    },
    async vgsLoaderAzure() {
      try {
        const cName = this.fields?.find(el=>el.name === "Custom_PaymentDomain")
        const vaultId = this.fields?.find(el => el.name === 'Custom_PaymentVault')
        if(!cName){
          throw Error('No vgs CNAME found in fields, can not continue')
        }
        if(!vaultId){
          throw Error('No vgs VAULT_ID found in fields, can not continue')
        }
        this.$nextTick(async () => {
          this.collect = await loadVGSCollect({
            vaultId: vaultId.value,
            environment: process.env.VUE_APP_VGS_ENV_WAFFLE,
            version: '2.18.0',
          })
          // https://www.verygoodsecurity.com/docs/vgs-collect/js/integration#form-state
          this.vgsForm = await this.collect.init(state => {
            this.vgsFieldState = state
          })
          this.vgsForm.useCname(cName.value);

          this.isVgsFormReady = true;
        })

      } catch (e) {
        console.warn(e)
        throw e;
      }
    },
    loadVgsField({targetId, fieldSettings, vgsName, question}) {
      if (this.vgsFieldsReady[vgsName] && toRaw(this.vgsFieldState)?.[vgsName]) {
        toRaw(this.vgsFieldsReady[vgsName]).delete()
        delete this.vgsFieldsReady[vgsName]
        delete this.vgsFieldNameToQuestionFieldName[vgsName]
      }
      //toRaw is needed due to incompatibility with proxy : https://github.com/verygoodsecurity/vgs-collect-js/issues/38
      this.$nextTick(() => {
        this.vgsFieldNameToQuestionFieldName[vgsName] =  question.name;
        this.vgsFieldsReady[vgsName] = toRaw(this.vgsForm).field(targetId, toRaw(fieldSettings))
      })
    },
    handleRemoveVgsField(vgsFieldName) {
      const field = toRaw(this.vgsFieldsReady[vgsFieldName])
      field.delete()
      this.$nextTick(() => {
        delete this.vgsFieldsReady[vgsFieldName]
      })
    }
  }
}
</script>
<style scoped>
.waffle.page-context form {
  scroll-snap-type: y mandatory;
}

</style>